export enum MaterialIcons {
  AdsClick = "ads_click",
  // ArrowRight = "arrow_right",
  ChevronLeft = "chevron_left",
  Clock = "pace",
  Delete = "delete",
  Info = "info",
  Menu = "menu",
  // QuestionMark = "question_mark",
  PlayArrow = "play_arrow",
  PlayCircle = "play_circle",
  Quiz = "quiz",
  StackedTicks = "library_add_check",
  // SwipeDown = "swipe_down"
}
